<app-view-loading *ngIf="carregando"></app-view-loading>

<div class="gera-orcamento" *ngIf="!carregando">
  <div class="container" *ngIf="!Consultor">
    <app-selecionar-consultor *ngIf="Orcamento.AgenciaId" [reserva]="Orcamento"
      (selecionou)="selecionaConsultor($event)"></app-selecionar-consultor>
  </div>
  <div class="container" *ngIf="Consultor">
    <div class="d-flex align-items-center mb-1">
      <div class="dropdown">
        <!-- <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
          <i class="fas fa-print fs-5" title="Email/Download/Impressão"></i>
        </button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
          <li>
            <a class="dropdown-item" role="button" (click)="orcamentoOpcoesSimplificado()">Simplificado</a>
          </li>
          <li>
            <a class="dropdown-item" role="button" (click)="orcamentoOpcoesCompleto()"> Completo</a>
          </li>
        </ul> -->
      </div>
      <div class='flex me-4' *ngIf="Orcamento.Status == 6 && !Orcamento.LiberarVoucher && liberar_voucher">
        <a style="cursor:pointer" (click)="confirmarLiberar()"><i class="fas fa-unlock"></i>{{"Liberar Voucher" |
          translate }}</a>
      </div>
      <div style="display: contents;">
        {{'Consultor:' | translate}} {{ Orcamento.Consultor?.Nome + " " + Orcamento.Consultor?.Sobrenome }}
        <button href="" data-bs-toggle="modal" #selecionaAgente data-bs-target="#selecionaConsultor"
          class="btn btn-success" style="margin-left: 20px;"><i class="far fa-edit" id="consultor"></i> {{'Alterar' |
          translate}}</button>
        <div class="dropdown">
          <button class="btn btn-success dropdown-toggle" type="button" id="dropdownMenuButton1"
            data-bs-toggle="dropdown" aria-expanded="false" style="margin-left: 20px;">
            <i class="fas fa-print" title="Email/Download/Impressão"></i>
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li>
              <a class="dropdown-item" role="button" (click)="orcamentoOpcoesSimplificado()">{{"Simplificado" |
                translate }}</a>
            </li>
            <li>
              <a class="dropdown-item" role="button" (click)="orcamentoOpcoesCompleto()"> {{"Completo" | translate
                }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="info">
      <div class="info-header row">
        <div class="col logo-empresa">
          <img
            src="{{ apiLocale + Orcamento.Agencia.Logo != null && apiLocale + Orcamento.Agencia.Logo != '' ? apiLocale + Orcamento.Agencia.Logo :  apiLocale + Orcamento.Agencia.Empresa.LogoInternet}}" />
        </div>
        <div class="col">
          <h5>{{ Orcamento.Agencia.NomeFantasia}}</h5>
          <p>{{ Orcamento.Agencia.Logradouro + ', ' + Orcamento.Agencia.Numero + ', ' +
            Orcamento.Agencia.Cidade.Nome +
            ' - ' + Orcamento.Agencia.Cidade.Estado.Iata }} </p>
        </div>
        <div class="col">
          <h6>{{"Agente" | translate}}</h6>
          <p>{{ Orcamento.Agente.Email }}</p>
          <div *ngIf="Orcamento?.Servicos[0]?.EmailConsultor != null && Orcamento?.Servicos[0]?.CodigoCliente != null">
            <h6>{{"Consultor no cliente" | translate }}:</h6>
            <p>{{ Orcamento?.Servicos[0]?.EmailConsultor }}</p>
          </div>
          <div *ngIf="Orcamento?.Servicos[0]?.EmailConsultor != null && Orcamento?.Servicos[0]?.CodigoCliente != null">
            <h6>{{"Orçamento no cliente" | translate }}:</h6>
            <p>{{ orcamentocliente }}</p>
          </div>
        </div>
        <div class="col">
          <div>
            <h6>{{"Criado em" | translate }}:</h6>
            <p>{{ Orcamento.Alteracoes.CriadoEm | date: "mediumDate" }}</p>
          </div>
          <div>
            <h6>{{"Criado por" | translate }}:</h6>
            <p>{{ Orcamento.Alteracoes.CriadoPor }}</p>
          </div>
        </div>
        <div class="col-1">
          <h6 class="txt-r">{{"Orçamento Nº" | translate}} {{+ this.idTEMP}}</h6>
          <br>
          <button class="btn btn-primary"
            *ngIf="usaLamina && (Orcamento.Hoteis?.length > 0 || Orcamento.HotelPacote?.length > 0)"
            (click)="abrirModalLaminas(contentLaminas)">{{"Gerar Lâmina" | translate}}</button>
        </div>
      </div>
      <div class="info-body">
        <div class="passageiros">
          <p class="title text-center"><i class="fas fa-user-friends"></i> {{"Passageiros" | translate}}</p>
          <div *ngFor="let quarto of Orcamento.Quartos ; let i = index">
            <h5>{{"Quarto" | translate}} {{quarto.quarto}}</h5>
            <div class="row" *ngFor="let pessoa of quarto.pessoas; let j = index">
              <div class='col'>
                <div class='row'>
                  <div class="col-1">
                    <div>
                      <label>{{"Tipo" | translate}}</label>
                      <input type="text" class="form-control" [disabled]="true"
                        [value]="pessoa.Tipo == 0 ? 'ADT' : (pessoa.Tipo == 1 ? 'CHD' : 'INF')" name="tipoPessoa">
                    </div>
                  </div>

                  <div class="col-12 col-md-3 row mb-3">
                    <!-- < <input type="text" class="form-control" autocomplete="off" [(ngModel)]="pessoa.Nome" name="Nome">
                      <span class="form-text">{{ validaCaracterEspecial(pessoa.Nome) ?
                        ("Não é permitido caracteres especiais" | translate) : ''}}</span> -->
                    <label>{{"Nome" | translate}}</label>
                    <!-- <app-typeahead class="col-12" name="Nome" [lista]="dataLista" [searchText]="pessoa.Nome" (searchFunction)="buscaPessoas($event, i, j, 'NOME')" (selectItem)="selecionaPessoa($event, i, j)"> -->
                      <input type="text" class="form-control" autocomplete="off" name="Nome" [(ngModel)]="pessoa.Nome"
                        name="Nome" />
                    <!-- </app-typeahead> -->
                  </div>

                  <div class="col-3">
                    <div>
                      <label>{{"Sobrenome" | translate}}</label>
                      <input type="text" class="form-control" autocomplete="off" [(ngModel)]="pessoa.Sobrenome"
                        name="sobrenome">
                      <span class="form-text">{{ validaCaracterEspecial(pessoa.Sobrenome) ? (
                        "Não é permitido caracteres especiais" | translate) : ''}}</span>
                    </div>
                  </div>

                  <div class="col-2">

                    <div>
                      <label>{{"Gênero" | translate}}</label>
                      <select class="custom-select form-select" [(ngModel)]="pessoa.Sexo">
                        <option selected disabled>Selecione</option>
                        <option value="M">{{"Masculino" | translate}}</option>
                        <option value="F">{{"Feminino" | translate}}</option>
                      </select>
                      <span *ngIf="!pessoa.Sexo" style="color:red">Selecione uma opção</span>
                    </div>
                  </div>

                  <div class="col-2">
                    <div>
                      <label>{{"Dt. Nascimento" | translate }}</label>
                      <input matInput type="text" class="form-control" autocomplete="off" mask="d0/M0/0000"
                        shownMaskExpression="dd/mm/aaaa" [(ngModel)]="pessoa.Nascimento" name="inputDataNascimento"
                        [class.erroBorda]="!pessoa.IdadeCertaVoltaViagem" (input)="setDataNascimento(pessoa)">

                      <!-- <input type="text" class="form-control" autocomplete="off" placeholder="dd/mm/aaaa"
                        [(ngModel)]="pessoa.Nascimento" name="inputDataNascimento"
                        [class.erroBorda]="!pessoa.IdadeCertaVoltaViagem" (keydown)="formatarDataManual($event); limpar($event)" (input)="setDataNascimento(pessoa)"> -->
                    </div>
                  </div>



                  <div class="col-1" *ngIf="pessoa.Tipo == 1 || pessoa.Tipo == 2">
                    <label>{{"Idade" | translate}}</label>
                    <div>
                      <input type="text" class="form-control" [(ngModel)]="pessoa.Idade" name="idade" disabled
                        [class.erroBorda]="!pessoa.IdadeCertaVoltaViagem">
                    </div>
                  </div>
                </div>
                <div class='row'>
                  <!-- <div class="col-3" *ngIf="pessoa.Pais && pessoa.Pais == 'BR' || !pessoa.Pais">
                    <div class="mb-3">
                      <label>{{"CPF" | translate}}</label>
                      <input type="text" class="form-control" autocomplete="off" mask="000.000.000-00"
                        [(ngModel)]="pessoa.CPF" name="CPF">
                    </div>
                  </div> -->
                  <div class="col-3" *ngIf="pessoa.Pais && pessoa.Pais == 'BR' || !pessoa.Pais">
                    <div class="mb-3">
                      <label>{{"CPF" | translate}}</label>
                      <div class="input-group mb-3">
                        <input type="text" class="form-control" autocomplete="off" mask="000.000.000-00"
                          [(ngModel)]="pessoa.CPF" name="CPF" title="Campo CPF do usuario">
                        <span title="Busca usuario de reservas anteriores pelo CPF"
                          *ngIf="Orcamento.Status != 6 || alterapaxcomreserva" class="input-group-text"
                          (click)="buscaPessoas(pessoa.CPF, i, j);" style="cursor: pointer;">
                          <i class="fas fa-search mx-auto"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-3" *ngIf="pessoa.Pais && pessoa.Pais != 'BR'">
                    <div class="mb-3">
                      <label>{{"Documento" | translate}}</label>
                      <div class="input-group mb-3">
                        <input type="text" class="form-control" autocomplete="off" [(ngModel)]="pessoa.CPF" name="CPF"
                          title="Campo Documento do usuario">
                        <span title="Busca usuario de reservas anteriores pelo CPF"
                          *ngIf="Orcamento.Status != 6 || alterapaxcomreserva" class="input-group-text"
                          (click)="buscaPessoasPorCpf(pessoa.CPF, i, j);" style="cursor: pointer;">
                          <i class="fas fa-search mx-auto"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-2">
                    <div class="mb-3">
                      <label>{{"Passaporte" | translate}}</label>
                      <input type="text" class="form-control" autocomplete="off" [(ngModel)]="pessoa.Passaporte"
                        name="Passaporte">
                    </div>
                  </div>
                  <div class="col-2">
                    <div class="mb-3">
                      <label>{{"E-mail" | translate}}</label>
                      <input type="email" class="form-control" autocomplete="off" [(ngModel)]="pessoa.Email"
                        name="Email">
                    </div>
                  </div>
                  <div class="col-2">
                    <div class="mb-3">
                      <label>{{"País" | translate}}</label>
                      <select class="form-control" [(ngModel)]="pessoa.Pais" (change)="onPaisChange(pessoa)">
                        <option *ngFor="let pais of paises" [value]="pais.code">
                          {{pais.code}} ({{pais.ddi}})
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-2">
                    <div class="mb-3">
                      <label>{{"Telefone" | translate}}</label>
                      <input type="text" class="form-control" autocomplete="off" [mask]="pessoa.mask"
                        [(ngModel)]="pessoa.Telefone" name="Telefone">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="row text-end">

            <div class="col-md-12 _mt-20" *ngIf="mensagemIdadeCertaVoltaViagem">
              <div class="alert alert-danger alert-dismissible" style="width: 100%">
                <a href="#" class="close" data-bs-dismiss="alert" aria-label="close">&times;</a>
                <div [innerHTML]="mensagemIdadeCertaVoltaViagem"> </div>
              </div>
            </div>

            <div class="col-md-12 _mt-20" *ngIf="mensagensErroPessoas">
              <div class="alert alert-danger alert-dismissible" style="width: 100%">
                <a href="#" class="close" data-bs-dismiss="alert" aria-label="close">&times;</a>
                <ul>
                  <li *ngFor="let mensagem of mensagensErroPessoas">{{mensagem}}</li>
                </ul>
              </div>
            </div>
            <div class='col-md-12 mt-4'>
              <button class="btn btn-success" (click)="salvarDadosPessoas()"
                *ngIf="Orcamento.Status != 6 || alterapaxcomreserva"><i class="fas fa-check"></i>
                <!-- [disabled]="!paxValido()" -->
                {{"Confirmar passageiros" | translate}}</button>
            </div>
          </div>
        </div>

        <div class="aereo">
          <div class='row d-flex'>
            <div class='col-4 flex-start'>
              <button class="btn btn-outline-secondary" (click)="adicionarItem($event, 'aereo')"
                *ngIf="Orcamento.Status !=6"><i class="fas fa-plus-circle"></i> {{"Alterar aéreo" | translate}}</button>
            </div>
            <div class='col-4 text-center flex-center'>
              <p class="title"><i class="fas fa-plane"></i> {{"Aéreo" | translate }}</p>
            </div>
          </div>
          <div class="col-4" *ngIf="Orcamento.Status !=6">
          </div>
          @for(aereo of Orcamento.Aereos; track aereo.Id;) {
          <app-aereo-card [aereo]="aereo" [statusOrcamento]="Orcamento?.Status" [termometroValido]="validaTermometro()"
            [idadeInvalida]="idadeInvalida" [LiberarVoucher]="Orcamento.LiberarVoucher"
            (carregarObjetoEmitter)="carregarObjeto($event)"
            (atualizarAereoEmitter)="atualizarCampoGenericoOrcamento('Aereos', $event)"
            (imprimirVoucherEmitter)="imprimirVoucher('aereo', $event)"
            (verificaIdadeValida)="idadeErrada()"></app-aereo-card>
          }
        </div>

        <div class="hospedagem">
          <div class='row'>
            <div class='col'>
              <button class="btn btn-outline-secondary" *ngIf='Orcamento.Status !=6'
                (click)="levaDataHotelProBuscador(contentHotelEDatas)"><i class="fas fa-plus-circle"></i>
                {{"Adicionar Hotel" | translate}}
              </button>
            </div>
            <div class='col text-center'>
              <p class="title"><i class="fas fa-concierge-bell"></i> {{"Hospedagem" | translate}} </p>
            </div>
            <div class='col'>
            </div>
          </div>
          @for (hotel of Orcamento.Hoteis; track hotel.Id) {
          <app-hotel-card [hotel]="hotel" [empresaId]="usuario?.EmpresaId"
            [agenteEmpresaId]="Orcamento.Agente.EmpresaId" [statusOrcamento]="Orcamento.Status"
            [LiberarVoucher]="Orcamento.LiberarVoucher" [perfilRoot]="perfilRoot" [quantidadeItens]="{
                hotel: Orcamento.Hoteis.length,
                servico: Orcamento.Servicos.length,
                aereo: Orcamento.Aereos.length
              }" [idadeInvalida]="idadeInvalida" (imprimirVoucherEmitter)="imprimirVoucher('hotel', $event)"
            (atualizarHotelEmitter)="atualizarCampoGenericoOrcamento('Hoteis', $event)"
            (carregarObjetoEmitter)="carregarObjeto($event)" (verificaIdadeValida)="idadeErrada()">
          </app-hotel-card>
          }
        </div>

        <div class="servico">
          <div class='row'>
            <div class='col'>
              <button class="btn btn-outline-secondary" *ngIf="Orcamento.Status != 6"
                (click)="adicionarItem($event, 'servico')"><i class="fas fa-plus-circle"></i>
                {{"Adicionar Serviço" | translate }}</button>
            </div>
            <div class='col text-center'>
              <p class="title"><i class="fas fa-route"></i> {{ "Serviço" | translate }}</p>
            </div>
            <div class='col'>
            </div>
          </div>
          @for(servico of Orcamento.Servicos; track servico.Id;){
          <app-servico-card [servico]="servico" [empresaId]="Orcamento.Agente.EmpresaId" [indice]="$index"
            [termometroValido]="validaTermometro()" [statusOrcamento]="Orcamento.Status" [perfilRoot]="perfilRoot"
            [liberarVouhcer]="Orcamento.LiberarVoucher" [quantidadeItens]="{
                Hoteis: Orcamento.Hoteis,
                servico: Orcamento.Servicos.length,
                Aereos: Orcamento.Aereos
              }" [idadeInvalida]="idadeInvalida" (imprimirVoucherEmitter)="imprimirVoucher('servico', $event)"
            (atualizarServicoEmitter)="atualizarCampoGenericoOrcamento('Servicos', $event)"
            (carregarObjetoEmitter)="carregarObjeto($event)" (verificaIdadeValida)="idadeErrada()"></app-servico-card>
          }
        </div>

        <div *ngIf="usaCarro" class="carro">
          <div class="row">
            <div class='col'>
              <button class="btn btn-outline-secondary" *ngIf="Orcamento.Status != 6"
                (click)="adicionarItem($event, 'carro')"><i class="fas fa-plus-circle"></i> {{"Adicionar Carro" |
                translate }}</button>
            </div>
            <div class='col text-center'>
              <p class="title"><i class="fas fa-car"></i> {{ "Carro" | translate }}</p>
            </div>
            <div class='col'>
            </div>
          </div>
          <div class="mb-4" *ngFor="let carro of carros; let indice = index">
            <div class="row header-row">
              <div class="col">
                <h5>{{"Carro" | translate}} {{indice+ 1}}</h5>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col title d-flex flex-column align-items-start">
                <h5>{{ carro.Descricao }} <span *ngIf="usuario.EmpresaId">{{ ' - ' + carro.Fornecedor}}</span></h5>
                <strong style="font-size: 14px;">{{"Proteções Escolhidas" | translate}}</strong>
                <span style="font-size: 12px;" class="text-success text-center"
                  *ngFor="let protecao of carro.Protecoes">
                  {{protecao.Titulo}} ({{protecao.Codigo}}) - {{carro.MoedaListagem.Sigla}}
                  {{protecao.ValorNet | currency: carro.MoedaListagem.Sigla :'':'2.2-2'}}
                </span>

                <div class="row mt-3">
                  <div class="col flex" [ngSwitch]="carro.Status">
                    <h6>{{ "Status" | translate}}:</h6>
                    <span *ngSwitchCase="0" class="badge rounded-pill bg-secondary">{{"Pendente" | translate}}</span>
                    <span *ngSwitchCase="1" class="badge rounded-pill bg-secondary">{{"Aguardando" | translate}}</span>
                    <span *ngSwitchCase="2" class="badge rounded-pill bg-secondary">{{"Reserva Parcial" |
                      translate}}</span>
                    <span *ngSwitchCase="3" class="badge rounded-pill bg-success">{{"Reservado" | translate}}</span>
                    <span *ngSwitchCase="4" class="badge rounded-pill bg-success">{{"Solicitado" | translate}}</span>
                    <span *ngSwitchCase="5" class="badge rounded-pill bg-success">{{"Emitido" | translate}}</span>
                    <span *ngSwitchCase="6" class="badge rounded-pill bg-success">{{"Pago" | translate }}</span>
                    <span *ngSwitchCase="7" class="badge rounded-pill bg-warning text-dark">{{"Problema Técnico" |
                      translate }}</span>
                    <span *ngSwitchCase="8" class="badge rounded-pill bg-warning text-dark">{{"Cancelado" |
                      translate}}</span>
                    <span *ngSwitchCase="9" class="badge rounded-pill bg-warning text-dark">{{"Excluído" |
                      translate}}</span>
                    <span *ngSwitchCase="10" class="badge rounded-pill bg-warning text-dark">
                      {{"Cancelamento com Problema" | translate }}</span>
                  </div>
                </div>
              </div>

              <div class="col">
                <strong>{{"Data e Hora de Retirada" | translate}}</strong>:
                <p>{{carro.DataHoraOrigem | date: "dd/MM/yyyy HH:mm"}}</p>

                <strong>{{"Data e Hora de Devolução" | translate}}</strong>:
                <p> {{carro.DataHoraDevolucao | date: "dd/MM/yyyy HH:mm"}}</p>
              </div>
              <div class="col">
                <strong>{{"Local e Endereço de Retirada" | translate}}</strong>:
                <p>{{carro.LocalOrigem}}<br>
                  {{carro.EnderecoOrigem != null ? carro.EnderecoOrigem : "Sem endereço cadastrado" }}</p>

                <strong>{{"Local e Endereco de Devolução" | translate}}</strong>:
                <p>{{carro.LocalDevolucao}}<br>
                  {{carro.EnderecoDevolucao != null ? carro.EnderecoDevolucao : "Sem endereço cadastrado" }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-12 table-responsive">
                <table class="table">
                  <thead>
                    <tr class="">
                      <th scope="col">
                        {{"Ocupante" | translate}}
                      </th>
                      <th scope="col">
                        {{"Núm. Portas" | translate}}
                      </th>
                      <th scope="col">
                        {{"Bagagem" | translate}}
                      </th>
                      <th scope="col">
                        {{"Ar Condicionado" | translate}}
                      </th>
                      <th scope="col">
                        {{"Transmissão" | translate}}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="">
                      <td>
                        {{carro.Pax}}
                      </td>
                      <td>
                        {{carro.Portas}}
                      </td>
                      <td>
                        {{carro.Bagagem}}
                      </td>
                      <td>
                        {{carro.TemAirCondicionado ? ("Sim" | translate) : ("Não" | translate)}}
                      </td>
                      <td>
                        {{carro.TransmissaoTipo | translate}}
                      </td>
                    </tr>
                </table>
              </div>
            </div>
            <div class="row mt-3 flex-row-reverse">
              <div class="col-12 d-flex justify-content-end">
                <!-- <h4 class="text-primary">{{"Total" | translate}}:
                                    <span style="font-size: 1.2rem;" class="text-success">{{carro.MoedaListagem.Sigla}} {{carro.ValorTotalListagem | currency: carro.MoedaListagem.Sigla :'':'2.2-2'}}</span>
                                </h4> -->
                <strong>{{ "Total" | translate}}</strong>:
                <strong class="price"> {{ carro.MoedaListagem.Sigla }} {{ carro.ValorTotalListagem | currency:
                  carro.MoedaListagem.Sigla : '' : '2.2-2' }}</strong>
              </div>
              <div class="col-12 col-md-3 d-flex flex-column justify-content-center align-items-end">
                <h6>{{"Taxas Adm" | translate}}:
                  <span style="font-size: 1.0rem;" class="text-success">{{carro.MoedaListagem.Sigla}}
                    {{carro.TaxaAdm + carro.TaxaExtra + carro.TaxaAdmProtecoes | currency: carro.MoedaListagem.Sigla
                    :'':'2.2-2'}}</span>
                </h6>
              </div>
              <div class="col-12 col-md-2 d-flex flex-column justify-content-center align-items-end">
                <h6>{{"Tarifa" | translate}}:
                  <span style="font-size: 1.0rem;" class="text-success">{{carro.MoedaListagem.Sigla}}
                    {{carro.ValorListagem | currency: carro.MoedaListagem.Sigla :'':'2.2-2'}}</span>
                </h6>
              </div>
            </div>
            <div class="row mt-2 d-flex flex-column justify-content-center">
              <div class="col-12 row d-flex flex-row-reverse justify-content-center justify-content-md-between">
                <div
                  class="col-12 col-md-3 d-flex flex-row-reverse justify-content-center align-items-center justify-content-md-start gap-3">
                  <button *ngIf="carro.Status == 0" (click)="abrirModal(contentCarroReserva, carro)"
                    class="btn btn-success">
                    {{'Reservar' | translate}}
                  </button>
                  <button *ngIf="(Orcamento.Status != 6 && (carro.Status == 3 || carro.Status == 4))"
                    (click)="abrirModal(contentCarroCancela, carro)" class="btn btn-danger">
                    {{'Cancelar' | translate}}
                  </button>
                  <button *ngIf="carro.Status == 0 || carro.Status == 8" class="btn btn-danger"
                    (click)="confirmarRemoverCarro(carro)">
                    {{'Excluir' | translate}}
                  </button>
                  <button *ngIf="(carro.Status == 3 || carro.Status == 4) && Orcamento.Status == 6"
                    class="btn btn-success" [disabled]="!Orcamento.LiberarVoucher"
                    (click)="imprimirVoucher('carro', carro)">
                    {{(Orcamento.LiberarVoucher ? ('Voucher' | translate) : ('Voucher Pendente' | translate))}}
                  </button>
                </div>
                <div class="col-12 col-md-3 mt-2 mt-md-0 d-flex align-items-center align-items-md-start flex-column"
                  *ngIf="carro.PrazoCancelamento">
                  <p class="text-warning mb-1">Prazo de Cancelamento:</p>
                  <a class="text-muted"> {{carro.PrazoCancelamento | date :'dd/MM/yyyy'}}</a>
                </div>
                <div class="col-12 col-md-3 mt-2 mt-md-0 d-flex flex-column align-items-center align-items-md-start"
                  *ngIf="carro.DataReserva">
                  <p class="text-warning mb-1">Data da Reserva:</p>
                  <a class="text-muted"> {{carro.DataReserva | date :'dd/MM/yyyy HH:mm:ss'}}</a>
                </div>
                <div class="col-12 col-md-3 mt-2 mt-md-0 d-flex flex-column align-items-center align-items-md-start"
                  *ngIf="carro.DataCancelamento">
                  <p class="text-warning mb-1">Data do Cancelamento:</p>
                  <a class="text-muted"> {{carro.DataCancelamento | date :'dd/MM/yyyy HH:mm:ss'}}</a>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="mensagensSucessoCarro?.length > 10">
              <div class="alert alert-success alert-dismissible" style="width: 100%">
                <a class="close" data-bs-dismiss="alert" (click)="mensagensSucessoCarro = ''"
                  aria-label="close">&times;</a>
                <ul>
                  <li>{{mensagensSucessoCarro}}</li>
                </ul>
              </div>
            </div>

            <div class="row" *ngIf="mensagensErroCarro?.length > 10">
              <div class="alert alert-danger alert-dismissible" style="width: 100%">
                <a class="close" data-bs-dismiss="alert" (click)="mensagensErroCarro = ''"
                  aria-label="close">&times;</a>
                <ul>
                  <li>{{mensagensErroCarro}}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="beto" *ngIf="USA_BETO">
          <div class='row'>
            <div class='col'>
              <button class="btn btn-outline-secondary" *ngIf="Orcamento.Status != 6"
                (click)="adicionarItem($event, 'beto')"><i class="fas fa-plus-circle"></i>
                {{"Adicionar Ingresso" | translate }}</button>
            </div>
            <div class='col text-center'>
              <p class="title"><i class="fa fa-hat-cowboy-side"></i> {{ "Beto Carrero" | translate }}</p>
            </div>
            <div class='col'>
            </div>
          </div>
          @for(beto of Orcamento.BetoCarreroIngressos; track beto.Id){
          <app-ingressos-card [beto]="beto" [termometroValido]="validaTermometro()" [idadeInvalida]="idadeInvalida"
            (carregarObjetoEmitter)="carregarObjeto($event)" (imprimirVouhcherEmitter)="imprimirVoucher('beto', $event)"
            (atualizarBetoEmitter)="atualizarCampoGenericoOrcamento('BetoCarreroIngressos', $event)"
            (verificaIdadeValida)="idadeErrada()"></app-ingressos-card>
          }
        </div>

        <div class="pacote" *ngIf="usaPacote">
          <div class='row d-flex justify-content-center'>
            <div class='col-md-4'>
              <p class="title text-center"><i class="fas fa-star"></i> {{ Orcamento.PacoteReservas.length > 0 &&
                Orcamento.PacoteReservas[0].Pacote.Evento ? "Evento" : "Pacote" | translate }}
              </p>
            </div>
          </div>

          @for(pacoteReserva of Orcamento.PacoteReservas; track pacoteReserva.Id ){
          <app-pacote-card [pacoteReserva]="pacoteReserva" [statusOrcamento]="Orcamento.Status"
            [liberarVoucher]="Orcamento.LiberarVoucher" [idadeInvalida]="idadeInvalida"
            (atualizarPacoteEmitter)="atualizarCampoGenericoOrcamento('PacoteReservas', $event)"
            (imprimirVoucherEmitter)="imprimirVoucher('pacote', $event)"
            (verificaIdadeValida)="idadeErrada()"></app-pacote-card>
          }
        </div>

        <div class="produtoOff">
          <div class='row'>
            <div class='col' *ngIf="usuario.EmpresaId !== null && usuario.EmpresaId !== undefined">
              <button class="btn btn-outline-secondary" (click)="abrirModalProdutoOffline(contentProdutoOffline)"><i
                  class="fas fa-plus-circle"></i>
                {{"Adicionar Produto" | translate }}</button>
            </div>
            <div class='col text-center'>
              <p class="title text-center"><i class="fas fa-clipboard-list fa-lg icone-item"></i> {{"Produtos Offline" |
                translate }}</p>
            </div>
            <div class='col'>
            </div>
          </div>
          <table *ngIf="Orcamento.OfflineProdutos && Orcamento.OfflineProdutos.length > 0" class="table">
            <thead>
              <tr>
                <th scope="col">Id</th>
                <th scope="col-2">Título</th>
                <th scope="col">Tipo</th>
                <th scope="col">Data In</th>
                <th scope="col">Data Out</th>
                <th scope="col">Pax</th>
                <th scope="col">Valor Venda</th>
                <!-- <th *ngIf="Orcamento.Status == 6" scope="col">Voucher</th> -->
                <th scope="col" class="text-center">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let produtooffline of Orcamento.OfflineProdutos">
                <td scope="col">{{produtooffline.Id}}</td>
                <td scope="row" class="col-2">{{produtooffline.Titulo}}</td>
                <td class="col">{{produtooffline.OfflineProdutoTipo.Descricao}}</td>
                <td class="col">{{produtooffline.dtIn | date: 'dd/MM/yyyy'}}</td>
                <td class="col">{{produtooffline.dtOut | date: 'dd/MM/yyyy'}}</td>
                <td class="col">{{(produtooffline.QtdInf + produtooffline.QtdChd + produtooffline.QtdAdt)}}</td>
                <td class="col">{{produtooffline.Moeda.Sigla}}&nbsp;{{produtooffline.ValorTotal | currency
                  :'BRL':'':'2.2-2'}}</td>
                <td class="col text-center">
                  <button type="button" (click)="abrirModalProdutoOffline(contentProdutoOffline, produtooffline.Id)"
                    class="btn btn-xs botao-editar" style="margin-left: 5px" title="Alterar"><span
                      class="fa fa-pen"></span>
                  </button>
                  <button type="button" (click)="removerProdutoOffline(produtooffline)" class="btn btn-xs botao-excluir"
                    style="margin-left: 5px" title="Remover"><span class="fa fa-trash"></span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="circuito">
          <div class='row'>
            <div class='col'>
            </div>
            <div class='col text-center'>
              <p class="title text-center"><i class="fas fa-globe fa-lg icone-item"></i> {{"Circuito" | translate }}</p>
            </div>
            <div class='col'>
            </div>

            <div *ngFor="let circuito of Orcamento.Circuitos">
              <div class="row mb-2 mb-md-2">
                <div class="col-sm-6 mb-2 mb-md-2 align-self-center">
                  <h2 class="px-2 px-md-2">{{circuito?.Titulo}} ({{circuito?.Fornecedor + "/" + circuito?.CodigoCircuito}})</h2>
                </div>
                <div class="col-sm-2 text-center mb-2 align-self-center">
                  <div class="col-md-8 align-self-center" *ngIf="circuito?.Localizador != undefined">
                    <span class="badge rounded-pill bg-info">Loc: {{circuito?.Localizador}}</span>
                  </div>
                </div>
                <div class="col-sm-2 text-center mb-2 mb-md-2 align-self-center">
                  <a (click)="modalDetalhes(contentCircuitoDetalhes, circuito)"
                    class="btn-detalhes">{{'Detalhes' | translate}}</a>
                </div>
                <div class="col-sm-2 mb-2 mb-md-2 align-self-center text-center">
                  <div class="col-md-8 align-self-center" [ngSwitch]="circuito.Status">
                    <span *ngSwitchCase="0" class="badge rounded-pill bg-secondary">{{"Pendente" | translate}}</span>
                    <span *ngSwitchCase="1" class="badge rounded-pill bg-secondary">{{"Aguardando" | translate }}</span>
                    <span *ngSwitchCase="2" class="badge rounded-pill bg-secondary">{{"Reserva Parcial" | translate}}</span>
                    <span *ngSwitchCase="3" class="badge rounded-pill bg-success">{{"Reservado" | translate}}</span>
                    <span *ngSwitchCase="4" class="badge rounded-pill bg-success">{{"Solicitado" | translate}}</span>
                    <span *ngSwitchCase="5" class="badge rounded-pill bg-success">{{"Emitido" | translate}}</span>
                    <span *ngSwitchCase="6" class="badge rounded-pill bg-success">{{"Pago" | translate}}</span>
                    <span *ngSwitchCase="7" class="badge rounded-pill bg-warning text-dark">{{"Problema Técnico" | translate }}</span>
                    <span *ngSwitchCase="8" class="badge rounded-pill bg-warning text-dark">{{"Cancelado" | translate}}</span>
                    <span *ngSwitchCase="9" class="badge rounded-pill bg-warning text-dark">{{"Excluído" | translate}}</span>
                    <span *ngSwitchCase="10" class="badge rounded-pill bg-warning text-dark">{{"Cancelamento com Problema" | translate }}</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 mb-2 mb-md-2">
                <div class="col-md-12 row mb-2 mb-md-2">
                  <div class="col-md-4 text-center align-self-center">
                    <img [src]="circuito?.ImagemPrincipal" class="img_circuito">
                  </div>
    
                  <div class="col-md-4 text-center align-self-center">
                    <h5>{{'Cidade Inicial' | translate}}: <span class="text-muted">
                        {{circuito?.CidadeInicio}}</span></h5>
                    <h5 *ngIf="circuito?.Fornecedor != 'ST'">{{'Cidade Final' | translate}}:<span class="text-muted">
                        {{circuito?.CidadeFim?.length > 0 ? transformString(circuito?.CidadeFim) : ''}}</span></h5>
                    <h5 *ngIf="circuito?.Fornecedor != 'SAT'">{{circuito?.Fornecedor == 'EM' ? 'Temporada' : 'Categoria' | translate}}:<span class="text-muted">
                        {{circuito?.CategoriaNome}}</span></h5>
                  </div>
    
                  <div class="col-md-4 text-center align-self-center">
                    <h5>{{'CheckIn' | translate}}: <span class="text-muted">
                        {{circuito?.CheckIn | date: 'dd/MM/yyyy'}}<span *ngIf="circuito.NoitesAdcInicio > 0"> + {{ circuito.NoitesAdcInicio }} noites</span></span>
                    </h5>
                    <h5>{{'CheckOut' | translate}}: <span class="text-muted">
                        {{circuito?.CheckOut | date: 'dd/MM/yyyy'}}<span *ngIf="circuito.NoitesAdcFim > 0"> + {{ circuito.NoitesAdcFim }} noites</span></span>
                    </h5>
                  </div>
                </div>
              </div>
              <div class="card-body table-full-width table-responsive">
                <table class="table table-hover table-striped">
                  <thead>
                    <th class="text-center">{{'Apartamentos' | translate}}</th>
                    <th class="text-center">{{'Duração' | translate}}</th>
                    <th class="text-center">{{'Adicionais' | translate}}</th>
                    <th style="text-align: right">{{circuito?.Status == 0 ? 'Valor Aproximado' : 'Valor Total' | translate}}:
                    </th>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-center">
                        <span *ngIf="circuito?.Single > 0"><strong>{{"Single" | translate}}</strong>:
                          {{circuito?.Single}}</span>
                        <span *ngIf="circuito?.Double > 0"><strong>{{"Double" | translate}}</strong>:
                          {{circuito?.Double}}</span>
                        <span *ngIf="circuito?.Shared > 0"><strong>{{"Shared" | translate}}</strong>:
                          {{circuito?.Shared}}</span>
                        <span *ngIf="circuito?.Triple > 0"><strong>{{"Triple" | translate}}</strong>:
                          {{circuito?.Triple}}</span>
                        <span *ngIf="circuito?.Quadruple > 0"><strong>{{"Quadruple" | translate}}</strong>:
                          {{circuito?.Quadruple}}</span>
                      </td>
                      <td class="text-center">
                        <span>{{circuito?.Duracao}}
                          <span><strong>{{"Dias" | translate}}</strong></span>
                        </span>
                      </td>
                      <td class="text-center">
                        <span
                          *ngIf="circuito?.NoitesAdcInicio == 0 && circuito?.NoitesAdcFim == 0 && circuito?.TemTrasladoChegada == false && circuito?.TemTrasladoPartida == false && circuito?.CircuitoFlexivel == false">{{"Não Contém" | translate}}</span>
                        <span *ngIf="circuito?.NoitesAdcInicio > 0"><strong>{{"Noites Inicio" | translate}}</strong>:
                          {{circuito?.NoitesAdcInicio}}
                        </span>
                        <span *ngIf="circuito?.NoitesAdcFim > 0"><strong>{{"Noites Fim" | translate}}</strong>:
                          {{circuito?.NoitesAdcFim}}
                        </span>
                        <span *ngIf="circuito?.CircuitoFlexivel"><strong>{{"Circuito Flexível" | translate}}
                            ({{circuito?.CidadeInicioFlexivel+"/"+circuito?.CidadeFimFlexivel}})</strong>
                        </span>
                        <span
                          *ngIf="circuito?.TemTrasladoChegada || circuito?.TemTrasladoPartida"><strong>{{"Traslado Incluido" | translate}}:
                            {{circuito?.TemTrasladoChegada ? "Chegada" : ""}}
                            {{circuito?.TemTrasladoChegada && circuito?.TemTrasladoPartida ? " + " : ""}}
                            {{circuito?.TemTrasladoPartida ? "Partida" : ""}}</strong>
                        </span>
                      </td>
                      <td style="text-align:right">
                        <span style="font-size: 22px">
                          <strong>{{circuito?.MoedaListagem?.Sigla}}</strong>
                          {{circuito?.ValorListagem.toFixed(2)}}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="row">
                <div class="col-md-8 d-flex justify-content-around">
                  <p *ngIf="circuito?.PrazoCancelamentoWs != null" class="align-self-center">
                    <strong>{{'Prazo de Cancelamento' | translate}}:</strong>
                    {{circuito?.PrazoCancelamentoWs | date:'dd/MM/yyyy'}}
                  </p>
    
                  <p *ngIf="circuito?.Status == 3 && circuito?.DataReserva != null" class="align-self-center">
                    <strong>{{'Data da Reserva' | translate}}:</strong>
                    {{circuito?.DataReserva | date:'dd/MM/yyyy'}}
                  </p>
    
                  <p *ngIf="circuito.Status == 8 && circuito?.DataCancelamento != null" class="align-self-center">
                    <strong>{{'Data de Cancelamento' | translate}}:</strong>
                    {{circuito?.DataCancelamento | date:'dd/MM/yyyy'}}
                  </p>
    
                  <p *ngIf="circuito?.DataPreReserva != null && circuito?.Status == 2" class="align-self-center">
                    <strong>{{'Data da Pré-Reserva' | translate}}:</strong>
                    {{circuito?.DataPreReserva | date:'dd/MM/yyyy'}}
                  </p>
    
                  <p *ngIf="circuito?.DataLimiteReserva != null && circuito?.Status == 2" class="align-self-center">
                    <strong>{{'Validade da Pré-Reserva' | translate}}:</strong>
                    {{circuito?.DataLimiteReserva | date:'dd/MM/yyyy'}}
                  </p>
                </div>
                <div class="col-md-4 d-flex justify-content-end">
                  <button
                    *ngIf="(circuito?.Status == 3 || circuito?.Status == 2) && Orcamento.Status!=6 && !agente_nao_reserva"
                    (click)="abrirModalCancelarCircuito(contentCircuitoCancela, circuito)" class="btn btn-danger m-1"><span
                      class="fas fa-times-circle"></span>
                    {{ 'Cancelar' | translate}}
                  </button>
                  <button *ngIf="circuito?.Status == 0 || circuito?.Status == 8" class="btn btn-outline-danger"
                    (click)="removerCircuito(circuito)">{{'Excluir' | translate}}
                  </button>
                  <button *ngIf="(circuito?.Status == 2 || circuito?.Status == 0) && !agente_nao_reserva"
                    (click)="abrirModalCircuitoReserva(contentCircuitoReserva, circuito)"
                    class="btn btn-success">{{circuito?.Status == 2 ? 'Reservar' : 'Tarifar' | translate}}
                  </button>
                  <button *ngIf="circuito?.Status == 3 && Orcamento.Status==6" class="btn btn-success m-1"
                    (click)="imprimirVoucher('circuito', circuito)" [disabled]="!Orcamento.LiberarVoucher">
                    <span *ngIf="!Orcamento.LiberarVoucher" class="fas fa-exclamation-circle"></span>
                    <span *ngIf="Orcamento.LiberarVoucher" class="fas fa-check-circle"></span>
                    {{Orcamento.LiberarVoucher ? 'Voucher' : 'Voucher Pendente'}}
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- TODO: Verificar porque foi criado e arrumar CLICKUP -->
        <!-- <div class="hoteis mt-3" *ngFor="let hotel of Orcamento.Hoteis; let a = index">
          <div *ngFor="let servico of Orcamento.Servicos; let x = index">
            <div *ngIf="!carregando">
              {{ somaServico(x, Orcamento.Servicos[x].ValorVenda) }}
            </div>
          </div>

          <div *ngIf="podePagar">
            <p class="title text-center"><i class="fas fa-dollar-sign"></i> {{"Pagamento" | translate }}</p>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col-2">Hotel</th>
                  <th scope="col">Entrada</th>
                  <th scope="col">Saída</th>
                  <th scope="col" *ngIf="Orcamento.Aereos[0]">Total Aéreo</th>
                  <th scope="col">Total Hotel</th>
                  <th scope="col" *ngIf="Orcamento.Servicos[0]">Total Serviços</th>
                  <th scope="col-2">Total Opção</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row" class="col-2">
                    {{ hotel.Nome }}
                  </th>
                  <td class="col">
                    {{ hotel.Checkin | date: 'dd/MM/yyyy' }}
                  </td>
                  <td class="col">
                    {{ hotel.Checkout | date: 'dd/MM/yyyy' }}
                  </td>
                  <td class="col" *ngIf="Orcamento.Aereos[0]">
                    {{ Orcamento.Aereos[0].MoedaListagem.Simbolo }} {{Orcamento.Aereos[0].ValorVenda |
                    currency:'BRL':'':'2.2-2' }}
                  </td>
                  <td class="col">
                    {{ hotel.Quartos[0].MoedaListagem.Simbolo }} {{ hotel.ValorTotalListagem | currency:'BRL':'':'2.2-2'
                    }}
                  </td>
                  <td class="col" *ngIf="!servicoCarregando && Orcamento.Servicos[0]">
                    {{ Orcamento.Servicos[0].MoedaListagem.Simbolo }} {{ totalServico | currency:'BRL':'':'2.2-2' }}
                  </td>
                  <td class="col-2" *ngIf="!servicoCarregando">

                    <strong class="validacaoPreço4"
                      *ngIf="Orcamento.Aereos[0] == null && Orcamento.Servicos[0] == null">
                      {{ hotel.Quartos[0].MoedaListagem.Simbolo }} {{ hotel.ValorTotalListagem |
                      currency:'BRL':'':'2.2-2' }}
                    </strong>

                    <strong class="validacaoPreço3" *ngIf="(Orcamento.Aereos[0]) && (Orcamento.Servicos[0] == null)">
                      {{ hotel.Quartos[0].MoedaListagem.Simbolo }} {{ hotel.ValorTotalListagem +
                      Orcamento.Aereos[0].ValorVenda | currency:'BRL':'':'2.2-2' }}
                    </strong>

                    <strong class="validacaoPreço2" *ngIf="(Orcamento.Aereos[0] == null) && (Orcamento.Servicos[0])">
                      {{ hotel.Quartos[0].MoedaListagem.Simbolo }} {{ hotel.ValorTotalListagem + totalServico |
                      currency:'BRL':'':'2.2-2' }}
                    </strong>

                    <strong class="validacaoPreço1" *ngIf="(Orcamento.Aereos[0]) && (Orcamento.Servicos[0])">
                      {{ hotel.Quartos[0].MoedaListagem.Simbolo }} {{ totalServico + hotel.ValorTotalListagem +
                      Orcamento.Aereos[0].ValorVenda | currency:'BRL':'':'2.2-2' }}
                    </strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div> -->

        <div class="pagamento" *ngIf="Orcamento.PacoteReservas.length == 0">
          <p class="title text-center"><i class="fas fa-file-alt"></i> {{ "Totais por Opção" | translate
            }}
          </p>
          <div class="hoteis mt-3" *ngFor="let opcao of opcoesValores; let a = index">
            <div class='row'>
              <div class='col flex opcoesOrcamento'>
                <div>
                  <h5 style="display: inline;">{{"Opção" | translate}} {{opcao.opcao}}</h5>
                  <h5 style="float: right;">{{"Total Opção" | translate}} {{opcao.opcao}}:
                    {{Orcamento.Agencia.Empresa.MoedaPagamento.Sigla}}
                    {{opcao.valor | currency:'BRL':'':'1.2-2'}}
                  </h5>
                </div>

              </div>
            </div>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col-2">{{"Hotel" | translate}}</th>
                  <th scope="col">{{"Entrada" | translate}}</th>
                  <th scope="col">{{"Saída" | translate}}</th>
                  <th scope="col">{{"Incluso" | translate}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let dadoshoteis of opcao.dados">
                  <th scope="row" class="col-2">
                    {{ dadoshoteis.Nome }}
                  </th>
                  <td class="col">
                    {{ dadoshoteis.CheckinOpcao}}
                  </td>
                  <td class="col">
                    {{ dadoshoteis.CheckoutOpcao}}
                  </td>
                  <td>
                    {{incluso}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div>
          <p class="title text-center"><i class="fas fa-dollar-sign pagamento"></i> {{"Pagamento" | translate }}</p>
          <table class="table">
            <thead>
              <tr>
                <th>{{"Total" | translate }}</th>
                <th>{{"Valor Pago" | translate}}</th>
                <!-- <th>{{"Desconto" | translate}}</th> -->
                <th>{{"Saldo Pendente" | translate}}</th>
                <th *ngIf="usaTermometro">{{"Termômetro" | translate}}</th>
                <th *ngIf="Orcamento.ValorJuros>0">{{"Juros" | translate}}</th>
                <th>{{(Orcamento.ValorJuros==0?"Total":"Total (com juros)") | translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{Orcamento.Agencia.Empresa.MoedaPagamento.Sigla}}
                  {{Orcamento.ValorTotal | currency:'BRL':'':'1.2-2'}}
                </td>
                <td *ngIf="Orcamento.ValorJuros>0">{{Orcamento.Agencia.Empresa.MoedaPagamento.Sigla}}
                  {{(Orcamento.ValorJuros) | currency:'BRL':'':'1.2-2'}}
                </td>
                <!-- <td *ngIf="Orcamento.Desconto == 0">-</td>
              <td *ngIf="Orcamento.Desconto > 0">{{Orcamento.Agencia.Empresa.MoedaPagamento.Sigla}}
                {{Orcamento.Desconto | currency:'BRL':'':'1.2-2'}}
              </td> -->
                <td>{{Orcamento.Agencia.Empresa.MoedaPagamento.Sigla}}
                  {{ ( Orcamento.ValorTotal - Orcamento.ValorPago) | currency:'BRL':'':'1.2-2'}}
                </td>
                <td *ngIf="usaTermometro && (!Orcamento.ValorOver && !Orcamento.ValorDescontoComissao)"></td>
                <td *ngIf="usaTermometro && Orcamento.ValorOver">{{Orcamento.Agencia.Empresa.MoedaPagamento.Sigla}}
                  {{Orcamento.ValorOver | currency:'BRL':'':'1.2-2'}}</td>
                <td *ngIf="usaTermometro && Orcamento.ValorDescontoComissao">{{Orcamento.Agencia.Empresa.MoedaPagamento.Sigla}}
                  {{Orcamento.ValorDescontoComissao | currency:'BRL':'':'1.2-2'}}</td>
                <td>{{Orcamento.Agencia.Empresa.MoedaPagamento.Sigla}}
                  {{Orcamento.ValorJuros | currency:'BRL':'':'1.2-2'}}
                </td>
                <td>{{Orcamento.Agencia.Empresa.MoedaPagamento.Sigla}}
                  {{ (Orcamento.ValorTotal + Orcamento.ValorJuros) | currency:'BRL':'':'1.2-2'}}
                </td>
              </tr>

            </tbody>
          </table>
          <div class="text-end">
            <button class="btn btn-primary mr-1" *ngIf="usaTermometro && Orcamento.Status!=6 && !Orcamento.Agencia.EscondeTermometro"
              (click)="abrirModalTermometro(contentReservaTermometro, Orcamento)">{{"TERMÔMETRO" | translate}}</button>
            <button type="button" class="btn btn-success" (click)="carregar(Orcamento, 'pagamento')"
              *ngIf="Orcamento.Status != 6">{{ "Pagar" | translate }}</button>
            <button #pagamento data-bs-toggle="modal" data-bs-target="#pagamentoModal" style="display: none;"></button>
          </div>
        </div>

        <div *ngIf="pagamentosRealizados.length > 0">
          <p class="title text-center"><i class="fas fa-dollar-sign"></i> {{ "Pagamentos Realizados" | translate }}</p>
          <table class="table">
            <thead>
              <tr>
                <th>{{"Código" | translate}}</th>
                <th>{{"Forma" | translate}}</th>
                <th>{{"Data" | translate}}</th>
                <th>{{"Valor" | translate}}</th>
                <th>{{"Status" | translate}}</th>
                <th>{{"Ações" | translate}}</th>
                <th *ngIf="temPagamentoComTipo4()">{{"Contrato" | translate}} / Link</th>
                <th *ngIf="temPagamentoComTipo4()">{{"Status do Contrato"}}</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let pgto of pagamentosRealizados">
                <td>{{ pgto.Id}}</td>
                <td>{{ pgto.CondicaoPagamento.FormaPagamento.Descricao}} - {{pgto.CondicaoPagamento.Descricao}}</td>
                <td>{{ pgto.Alteracoes.CriadoEm | date: 'dd/MM/yyyy'}}</td>
                <td>{{Orcamento.Agencia.Empresa.MoedaPagamento.Sigla}} {{ pgto.Valor | currency:'BRL':'':'1.2-2'}}</td>
                <td [ngSwitch]="pgto.Status">
                  <span *ngSwitchCase="0" class="badge rounded-pill bg-secondary">Pendente</span>
                  <span *ngSwitchCase="1" class="badge rounded-pill bg-secondary">Enviado</span>
                  <span *ngSwitchCase="2" class="badge rounded-pill bg-success">Confirmado</span>
                  <span *ngSwitchCase="3" class="badge rounded-pill bg-warning text-dark">Recusado</span>
                  <span *ngSwitchCase="4" class="badge rounded-pill bg-success">Aprovado</span>
                  <span *ngSwitchCase="5" class="badge rounded-pill bg-warning text-dark">Cancelado</span>
                  <span *ngSwitchCase="6" class="badge rounded-pill bg-warning text-dark">Estornado</span>
                  <span *ngSwitchCase="7" class="badge rounded-pill bg-warning text-dark">Excluído</span>
                </td>
                <td [ngSwitch]="pgto.Status">
                  <div *ngSwitchCase="0">
                    <button *ngIf="pgto.TipoPagamento == 2 && usuario.EmpresaId != null" class="btn btn-info btn-sm"
                      (click)="consultarPagamento(pgto)" title="Consultar">Consultar
                    </button>
                    <button *ngIf="pgto.TipoPagamento == 2 && pgto.Link != null && pgto.Link && pgto.ChaveLink!=''"
                      class="btn btn-info btn-sm m-1" (click)="abrirLinkPagamento(pgto)" title="Acessar Link">
                      Acessar Link <i class="fas fa-link"></i>
                    </button>
                    <button *ngIf="pgto.TipoPagamento == 4" (click)="acessarFinanciamento(pgto)"
                      class="btn btn-info btn-sm" title="Acessar Financiamento">Acessar
                      Financiamento
                    </button>
                  </div>
                  <div *ngSwitchCase="3">
                    <button *ngIf="pgto.TipoPagamento == 4" (click)="acessarFinanciamento(pgto)"
                      class="btn btn-info btn-sm" title="Acessar Financiamento">Acessar
                      Financiamento
                    </button>
                  </div>
                  <div *ngSwitchCase="4">
                    <button *ngIf="pgto.TipoPagamento == 2" class="btn btn-danger btn-sm" (click)="estornar(pgto,i)"
                      title="Estornar">Estornar </button>
                    <button *ngIf="pgto.TipoPagamento == 4" (click)="acessarFinanciamento(pgto)"
                      class="btn btn-info btn-sm" title="Acessar Financiamento">Acessar
                      Financiamento</button>
                    <button *ngIf="pgto.TipoPagamento == 4"
                      [disabled]="!contratoAssinado(pgto.Id)||statusContrato(pgto.Id) != 1"
                      class="btn bbtn btn-info btn-sm" title="Boletos" (click)="acessarBoleto(pgto)">Ver Boletos
                    </button>
                  </div>
                </td>
                <td *ngIf="pgto.TipoPagamento == 4">
                  <span class="btn"
                    *ngIf="(pgto.Status == 2 || pgto.Status == 4) && statusContrato(pgto.Id) != 1 && (!contratoAssinado(pgto.Id)||statusContrato(pgto.Id) == 2)"
                    style="cursor: pointer;" title="Acessar o link do contrato." (click)="confirmarNovoLink(pgto.Id)"><i
                      class="olho fas fa-light fa-file icone-item"></i></span>
                  <span class="btn"
                    *ngIf="(pgto.Status == 2 || pgto.Status == 4) && statusContrato(pgto.Id) != 1 && (!contratoAssinado(pgto.Id)||statusContrato(pgto.Id) == 2)"
                    style="cursor: pointer;" title="Enviar Contrato por E-mail."
                    (click)="confirmarGeraChave(pgto.Id)"><i
                      class="olho fas fa-light fa-envelope icone-item"></i></span>
                  <span class="btn" *ngIf="(pgto.Status == 2 || pgto.Status == 4) && contratoAssinado(pgto.Id)"
                    style="cursor: pointer;" title="Ver Contrato" (click)="GeraChaveLinkPDF(pgto.Id)"><i
                      class="olho fas fa-light fa-eye icone-item"></i></span>
                </td>
                <td *ngIf="pgto.TipoPagamento == 4">
                  <div [ngSwitch]="statusContrato(pgto.Id)" class="mb-md-2" style="font-size: 14px;">
                    <span *ngSwitchCase="0" class="badge rounded-pill bg-warning text-dark">Pendente <span
                        *ngIf="contratoAssinado(pgto.Id)">Em
                        análise</span></span>
                    <span *ngSwitchCase="1" class="badge rounded-pill bg-success">Aprovado</span>
                    <span *ngSwitchCase="2" class="badge rounded-pill bg-danger">Reprovado</span>
                    <span *ngSwitchCase="3" class="badge rounded-pill bg-warning text-dark">Não Assinado</span>
                  </div>
                  <div>
                    <span>{{"Assinado" | translate}}: </span>
                    <span *ngIf="contratoAssinado(pgto.Id)" class="badge rounded-pill bg-secondary">{{"Sim"}}</span>
                    <span *ngIf="!contratoAssinado(pgto.Id)"
                      class="badge rounded-pill bg-warning text-dark">{{"Não"}}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="mb-5" *ngIf="usuario.EmpresaId != null">
          <app-log texto="{{'Ver Log de alterações' | translate}}" [showDetalhes]="true"
            [alteracoes]="Orcamento.Alteracoes" [entidade]="'Reserva'" [chave]="Orcamento.Id">Ver
            Alterações</app-log>
        </div>
        <!-- && Orcamento.Status == 6 -->
        <div *ngIf="usuario.EmpresaId != null && Orcamento.Status == 6">
          <a (click)="abrirModalSlip(contentSlip, Orcamento.Id)" type="buttom" class="btn btn-xs botao-editar"
            style="margin-left: 5px;" title="Ver Slip">
            <span style="color: #667;" class="fa fa-eye"> </span> <span
              style="font-size: 14px; color: #667; font-weight: bold; margin-left: 5px;">
              {{"VER SLIP DE CAIXA" | translate}}</span></a>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade bd-example-modal-lg" tabindex="-1" id="selecionaConsultor" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <app-selecionar-consultor *ngIf="Orcamento.AgenciaId" [reserva]="Orcamento"
            (selecionou)="selecionaConsultor($event)"></app-selecionar-consultor>
        </div>
        <div class="modal-footer">
          <div class='row'>
            <div class='col text-end'>
              <button class="btn btn-success" data-bs-dismiss="modal">{{"Fechar" | translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" tabindex="-1" id="selecionaAgente" role="dialog" aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{'Selecionar Agente' | translate}}</h5>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="form-check">
              <div class="row">
                <div class="col">
                  <div *ngFor="let agente of agenteLista" class="item">
                    <input class="form-check-input" type="radio" name="flexRadioDefault" (change)="changeAgente($event)"
                      value="{{agente.Id}}">
                    <label>{{ agente.Nome }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button (click)="mudarAgente();" type="button" class="btn btn-success" data-bs-dismiss="modal">
            Selecionar
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade bd-example-modal-xl" aria-labelledby="Modal Pagamento" id="pagamentoModal" role="document"
    aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true"
    *ngIf="pagamentoLoadded">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <app-reserva-pagamentos [reserva]="objeto" (alterou)="atualizarPagamentos($event)"
          (fechou)="pagamentoLoadded = false"></app-reserva-pagamentos>
      </div>
    </div>
  </div>

  <ng-template let-modal #contentLaminas>
    <app-laminas [Reserva]="Orcamento"></app-laminas>
  </ng-template>

  <ng-template let-modal #contentCarroReserva>
    <carro-reserva (alterou)="atualizarCarro($event)" [carro]="objModal" [paxes]="Orcamento.Pessoas"></carro-reserva>
  </ng-template>
  
  <ng-template let-modal #contentProdutoOffline>
    <app-produtooffline [ReservaId]="Orcamento.Id" [Id]="OfflineProdutoId" (alterou)="atualizarOfflineProduto($event)">
    </app-produtooffline>
  </ng-template>

  <ng-template #contentReservaTermometro let-modal>
    <reserva-termometro [reserva]="Orcamento" (alterou)="atualizarTermometro($event)"></reserva-termometro>
  </ng-template>

  <ng-template #contentSlip let-modal>
    <app-slip [ReservaId]="Orcamento.Id" [Id]="SlipId"></app-slip>
  </ng-template>

  <ng-template let-modal #contentCircuito>
    <app-circuito [ReservaId]="Orcamento.Id" [Id]="CircuitoId" (alterou)="atualizarCircuito($event)">
    </app-circuito>
  </ng-template>

  <ng-template let-modal #contentCircuitoDetalhes>
    <app-circuito-detalhes [Circuito]="itemDetalhes" [AgenciaId]="Orcamento.AgenciaId"></app-circuito-detalhes>
  </ng-template>

  <ng-template #contentCircuitoReserva let-modal>
    <ng-container [ngSwitch]="itemReserva.Fornecedor">
      <ng-container *ngSwitchCase="'ST'">
        <app-circuito-reserva [Circuito]="itemReserva" (alterou)="atualizarcircuito($event)"></app-circuito-reserva>
      </ng-container>
      <!-- <ng-container *ngSwitchCase="'SAT'">
        <circuito-reserva-satotours [Circuito]="itemReserva" (alterou)="atualizarcircuito($event)"></circuito-reserva-satotours>
      </ng-container>
      <ng-container *ngSwitchCase="'EM'">
        <circuito-reserva-europamundo [Circuito]="itemReserva" (alterou)="atualizarcircuito($event)">
        </circuito-reserva-europamundo>
      </ng-container>
      <ng-container *ngSwitchCase="'SRL'">
        <circuito-reserva-surland [Circuito]="itemReserva" (alterou)="atualizarcircuito($event)"></circuito-reserva-surland>
      </ng-container> -->
    </ng-container>
  </ng-template>

  <ng-template #contentCircuitoCancela let-modal>
    <app-circuito-cancela [Circuito]="itemReserva" (alterou)="atualizarcircuito($event)"></app-circuito-cancela>
  </ng-template>

  <ng-template #contentHotelEDatas>
    <div class="card">
      <div class="card-header">
        <h4>Escolha uma das datas ou prossiga sem a seleção.</h4>

      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12 row d-flex align-items-center" *ngFor="let hotelEData of hoteisEDatas;">
            <div class="col-5">
              <h6 class="m-0 p-0">{{hotelEData.Nome}}</h6>
            </div>
            <div class="col-2">
              <p class="m-0 p-0">{{hotelEData.Checkin | date: "dd/MM/yyyy"}}</p>
            </div>
            <div class="col-2">
              <p class="m-0 p-0">{{hotelEData.Checkout | date: "dd/MM/yyyy"}}</p>
            </div>
            <div class="col-3">
              <button class="btn btn-primary" (click)="adicionarItem(null, 'hotel', hotelEData)">
                Escolher Data
              </button>
            </div>
          </div>
          <div class="col-12 d-flex justify-content-center">
            <button class="ms-auto btn btn-secondary" (click)="adicionarItem(null, 'hotel')">
              Prosseguir sem a seleção
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #buscaPessoa>
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">{{'Selecionar Pessoa' | translate}}</h5>
      <button type="button" class="btn-close" (click)="fecharModal()"></button>
    </div>
    <div class="modal-body">
      <input type="text" class="form-control" placeholder="{{'Buscar' | translate}}" [(ngModel)]="cpf"
        (blur)="buscaPessoasPorCpf(cpf, indiceQuarto, indicePessoa) " />
    </div>
  </ng-template>